import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n.use(LanguageDetector).init({
  // fallbackLng, // language to use if translations are missing in the current language - set in TranslatorProvider
  // lng: 'xx-XX', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  // if you're using a language detector, do not define the lng option
  ns: 'translations',
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
